module.exports = __webpack_public_path__ + "static/media/sen_web_vertikal_rgb_.48fa8fa9.png";